import {i18n} from '@/plugins/i18next';

let DocumentType = {
  getDocumentTypes() {
    return [
      {id: 'globalContract', name: i18n.t('common:contract')},
      {id: 'globalDocument', name: i18n.t('common:documentation')},
      {id: 'localContract', name: i18n.t('book/issue:localContract')},
      {id: 'localDocumentation', name: i18n.t('book/issue:localDocumentation')},
      {id: 'invoiceDocumentation', name: i18n.t('book/issue:invoiceDocumentation')},
      {id: 'offerDocumentation', name: i18n.t('book/issue:offerDocumentation')},
      {id: 'taskDocumentation', name: i18n.t('book/issue:taskDocumentation')},
      {id: 'orderDocumentation', name: i18n.t('book/issue:orderDocumentation')}
    ]
  }
}

export default DocumentType;